"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRowHeightInfo = exports.TopAndBottomMarginsForRow = void 0;
var unit_converter_1 = require("@devexpress/utils/lib/class/unit-converter");
var TopAndBottomMarginsForRow = (function () {
    function TopAndBottomMarginsForRow() {
        this.topMargin = 0;
        this.bottomMargin = 0;
    }
    TopAndBottomMarginsForRow.prototype.addCellTopMargin = function (topMargin) {
        if (this.topMargin < topMargin)
            this.topMargin = topMargin;
    };
    TopAndBottomMarginsForRow.prototype.addCellBottomMargin = function (bottomMargin) {
        if (this.bottomMargin < bottomMargin)
            this.bottomMargin = bottomMargin;
    };
    TopAndBottomMarginsForRow.prototype.sumOfBoth = function () {
        return this.topMargin + this.bottomMargin;
    };
    return TopAndBottomMarginsForRow;
}());
exports.TopAndBottomMarginsForRow = TopAndBottomMarginsForRow;
var TableRowHeightInfo = (function () {
    function TableRowHeightInfo(cantSplit, height, horizontalAlignment) {
        this.cantSplit = cantSplit;
        this.preferredHeightValue = unit_converter_1.UnitConverter.twipsToPixelsF(height.value);
        this.preferredHeightType = height.type;
        this.contentHeight = 0;
        this.horizontalAlignment = horizontalAlignment;
    }
    return TableRowHeightInfo;
}());
exports.TableRowHeightInfo = TableRowHeightInfo;
